import { combineReducers } from "redux";
import applicant from "./applicant";
import configuration from "./configuration";
import status from "./status";
import institution from "./institution";

export interface BaseInterface {
    id: string;
    createdTime: Date;
    createdBy: string;
    modifiedTime?: Date;
    modifiedBy?: string;
    deletedTime?: Date;
    deletedBy?: string;
}

export interface Payload<T = any> {
    onSuccess?: (data: any) => void;
    onFailure?: (data: any) => void;
    headers?: { Authorization?: string; };
    input?: T;
    data?: T;
    noLoad?: boolean;
    message?: {
        success?: string;
        error?: string;
    }
}

const rootReducer = combineReducers({
    applicant,
    configuration,
    status,
    institution,
});

export default rootReducer;
